/*

  Implementated by Amit Sharma & Bryan Perez
  Dated : 11/26/2019

*/

import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { Row, ModalBody, Col, UncontrolledAlert } from 'reactstrap';
import { Field, reduxForm } from 'redux-form'
import queryString from 'query-string';
import { UpwardReduxCheckbox, UpwardReduxInput, UpwardLoadingButton } from "ui";
import FormValidators from "ui/FormValidators";
import { freeRegistrationCredentials } from "../../services/EmployerServices";
import { ThemeContext } from "../../context/ThemeContext";
// import {validateFnameLnameEmail} from "corp-site/services/fusionValidators";

class EmployerRegistrationForm extends Component {

   state = {
      errorMessages: [],
      isLoading: false,
      source: "ENTERPRISE_FREE"
   };

   componentDidMount = () => {
      //create source parameter from url
      let params = queryString.parse(this.props.location.search.toLowerCase());
      let source = '';
      if ("src" in params && params.src) {
         source = params.src;
      } else if ("cid" in params && params.cid) {
         source = params.cid;
      } else {
         source = "ENTERPRISE_FREE";
      }
      this.setState({
         source: source
      });
   };

   handleSubmit = (formData) => {

      const { accountType } = this.props;
      const { email } = this.props;
      const { isTermsAccepted, ...rest } = formData;
      const { source } = this.state;

      this.setState({
         isLoading: true,
         errorMessages: [],
         email: formData.email,
         password: formData.password
      });

      if (isTermsAccepted) {
         const payload = {
            ...rest,
            accountType: accountType,
            source: source,
            terms: true
         };

         this.props.email(payload.email);
         this.props.password(payload.password);

         freeRegistrationCredentials(payload).subscribe(res => {
            if (res && res.outcome) {
               this.props.onEmployerRegistrationFormSuccess && this.props.onEmployerRegistrationFormSuccess();
            } else {
               const errorMessages = res && res.errorMsgs ? res.errorMsgs : [];
               this.setState({
                  errorMessages: [...errorMessages],
                  isLoading: false
               });
            }
         }, err => console.log(err));
      } else {
         this.setState({
            errorMessages: ["You must agree to the Terms & Agreements."],
            isLoading: false
         });
      }
   };


   render() {
      const { errorMessages } = this.state;
      return (
         <Fragment>
            <div className="modal-header pt-3">
               <h5 className="modal-title" style={{ fontSize: "45px" }}>
                  {
                     this.props.accountType === 'ENTERPRISE_CUSTOM'
                        ? 'Speak to a representative'
                        : 'Create employer account'
                  }
               </h5>
            </div>
            <form onSubmit={this.props.handleSubmit(this.handleSubmit)} autoComplete="off">
               <ModalBody>
                  {
                     errorMessages && errorMessages.length > 0 &&
                     <UncontrolledAlert color="danger" className="custom-alert-failure">
                        {
                           errorMessages.map(
                              (message, index) => (`${message} `)
                           )
                        }
                     </UncontrolledAlert>
                  }
                  <Row>
                     <Col xs={{ "size": 10, "offset": 1 }}>
                        <div className="form-group roundLgInput">
                           <Field type="email" name="email" placeholder="Email"
                              validate={[FormValidators.required, FormValidators.email]}
                              component={UpwardReduxInput} autoComplete="new-email" />
                        </div>
                        <div className="form-group roundLgInput">
                           <Field type="password" name="password" placeholder="Password"
                              validate={[FormValidators.required]}
                              component={UpwardReduxInput} autoComplete="new-password" />
                        </div>
                     </Col>
                  </Row>
                  <Row className="py-2">
                     <Col xs={{ "size": 10, "offset": 1 }} lg={{ "size": 6, "offset": 3 }}>
                        <UpwardLoadingButton
                           disabled={
                              this.props.isIPAddressBlacklisted
                              || !this.props.isValidInternational
                           }
                           block
                           type="submit"
                           color="primary"
                           size="lg"
                           isLoading={this.state.isLoading}
                           className={"btn btn-xl btn-block btn-rounded btn-dark-" + this.context}
                        >
                           <b>Continue</b>
                        </UpwardLoadingButton>
                     </Col>
                  </Row>
                  <Row className="text-left py-3">
                     <Col xs={{ "size": 10, "offset": 1 }}>
                        <Field type="checkbox" name="isTermsAccepted" id="isTermsAccepted"
                           validate={[FormValidators.required]}
                           component={UpwardReduxCheckbox}
                           label={
                              <Fragment>
                                 I agree to the
                                     <a
                                    href="/employer-terms.jsp"
                                    target="_blank">
                                    &nbsp;Terms of Use
                                     </a>
                                 .
                                  </Fragment>
                           } />
                     </Col>
                  </Row>
               </ModalBody>
               <div style={{ position: "absolute", bottom: "5px", right: "25px" }}>
                  <p className="float-right">
                     Already have an account? <Link to="/employers?signin=y">Sign in</Link></p>
               </div>
            </form>
         </Fragment>
      )
   }
}

EmployerRegistrationForm.contextType = ThemeContext;
EmployerRegistrationForm = withRouter(EmployerRegistrationForm);

export default reduxForm({
   form: 'employerRegistration'
})(EmployerRegistrationForm);
